import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class ConsolidatedBillingOrderSelectListCtrl implements IController {
  selectedId: any;
  optionIds: any;
  excludeIds: any;
  billingAccountIds: string[];
  onChange: Function;

  private consolidatedBillingOrdersRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private excludeKeys: any;

  /* @ngInject */
  constructor(private $log, private $consolidatedBillingOrders, private $infiniteScroll) {
  }

  $onInit() {
    this.consolidatedBillingOrdersRef = this.$consolidatedBillingOrders();
    this.loadLimit = 20;

    this.consolidatedBillingOrdersRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.consolidatedBillingOrdersRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  private _reload() {
    this.consolidatedBillingOrdersRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit:  this.loadLimit,
      query:  this.queryString,
      billingAccountIds: this.billingAccountIds,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.billing-accounts')
  .component('consolidatedBillingOrderSelectList', {
    bindings: {
      selectedId: '<',
      optionIds: '<?',
      excludeIds: '<?',
      billingAccountIds: '<?',
      onChange: '&'
    },
    template: require('./consolidated-billing-order-select-list.html').default,
    controller: ConsolidatedBillingOrderSelectListCtrl
  });
